import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TransparentModalOpen {
    isOpen: boolean;
}
const initialState: TransparentModalOpen = {
    isOpen: false,
};
const TransparentModalOpenSlice = createSlice({
    name: 'TransparentModalOpenSlice',
    initialState,
    reducers: {
        setTransparentModalOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setTransparentModalOpen } = TransparentModalOpenSlice.actions;
export default TransparentModalOpenSlice.reducer;
